module.exports = __webpack_public_path__ + "img/drag_handle.525c4050.svg";